module.exports = __webpack_public_path__ + "assets/interface/hex_dashed.png";